import { useState, useCallback, useEffect, useRef } from "react"
import { useLocation } from "react-router"
import { Link } from "react-router-dom"
import { useTranslation } from "react-i18next"
import {
  LinkGroup,
  LinkItem,
  OpenToggle,
  CloseToggle,
  NavMenuHolder,
  ButtonHolder
} from "./NavigationMenu.style"
import { motion } from "framer-motion"
// eslint-disable-next-line
import Pusher from "pusher-js"
import homeIcon from "./home.svg"
import lightsIcon from "./lights.svg"
import refreshIcon from "./refresh.svg"
// import zones from "../LightsBroadcaster/zones";
import { io } from "socket.io-client"

import { TurnLightsOff } from "../../state/lights"
import { useStore } from "../../state/store"

const url = process.env.REACT_APP_MARKETING_SUITE
// eslint-disable-next-line
const role = process.env.REACT_APP_ROLE

const ContainerVariants = {
  show: {
    transition: {
      staggerChildren: 0.09,
      delayChildren: 0.3
    }
  },
  hidden: { staggerChildren: 0.05, staggerDirection: -1 }
}

const ItemVariants = {
  show: {
    y: 0,
    opacity: 1,
    transition: {
      y: { stiffness: 1000, velocity: -100 }
    }
  },
  hidden: {
    y: 50,
    opacity: 0,
    transition: {
      y: { stiffness: 1000 }
    }
  }
}

const NavigationMenu = ({ routes }) => {
  const { t } = useTranslation()
  const [isOpen, setIsOpen] = useState(false)

  const setApartmentFinderActive = useStore(state => state.setApartmentFinderActive)
  const setCurrentCameraPositionID = useStore(state => state.setCurrentCameraPositionID)
  const handleToggleMenu = useCallback(() => {
    setIsOpen(open => !open)
  }, [])

  const { pathname } = useLocation()
  const { path: currentLocation } =
    routes.find(({ path }) => pathname.startsWith(path)) || routes[0]

  // eslint-disable-next-line
  const channel = useRef()
  const socket = useRef()

  useEffect(() => {
    if (url && role) {
      socket.current = io(url)
      socket.current.on("reload", data => {
        window.location.href = "/"
      })
    }
  }, [])

  const enterApartmentFinderClick = () => {
    setApartmentFinderActive(true)
    setCurrentCameraPositionID("site")
  }

  const role = process.env.REACT_APP_ROLE

  return (
    <NavMenuHolder isopen={isOpen}>
      {role !== "recipient" && <OpenToggle onClick={handleToggleMenu} />}
      <LinkGroup>
        <motion.ul
          variants={ContainerVariants}
          initial="hidden"
          animate={isOpen ? "show" : "hidden"}
        >
          {routes.map(({ path }, index) => (
            <LinkItem
              key={path}
              onClick={
                index === 2
                  ? () => enterApartmentFinderClick()
                  : () => setApartmentFinderActive(false)
              }
              variants={ItemVariants}
              whileHover={{ scale: 1.01 }}
              whileTap={{ scale: 1.01 }}
              style={{ listStyleType: "none" }}
            >
              <Link onClick={handleToggleMenu} to={isOpen ? path : "#"}>
                {isOpen
                  ? t(`navigation.${path}`)
                  : index === 0
                  ? t(`navigation.${currentLocation}`)
                  : t(`navigation.${path}`)}
              </Link>
            </LinkItem>
          ))}
        </motion.ul>
        <CloseToggle onClick={handleToggleMenu} />
      </LinkGroup>

      <div
        style={{
          position: "absolute",
          display: "flex",
          zIndex: 100000000,
          padding: "4px",
          top: "10px",
          right: "10px"
          // border: "white solid 2px"
        }}
      >
        <ButtonHolder role={role}>
          {role === "sender" && (
            <Link to="/" onClick={() => setIsOpen(false)}>
              <img
                src={refreshIcon}
                alt="refresh"
                onClick={() => {
                  socket.current.emit("reload", true)
                  setTimeout(() => {
                    window.location.reload()
                  }, 500)
                }}
                style={{
                  cursor: "pointer",
                  display: "block",
                  width: "100%"
                }}
              />
            </Link>
          )}
          {role === "sender" && (
            <img
              src={lightsIcon}
              alt="lights-off"
              // onClick={lightsOff}
              onClick={() => TurnLightsOff("test")}
              style={{
                cursor: "pointer",
                display: "block",
                width: "100%"
              }}
            />
          )}
          <Link to="/" onClick={() => setIsOpen(false)}>
            <img
              src={homeIcon}
              alt="home"
              style={{
                cursor: "pointer",
                display: "block",
                width: "100%"
              }}
            />
          </Link>
        </ButtonHolder>
      </div>
    </NavMenuHolder>
  )
}

export default NavigationMenu

// import { useState, useCallback } from "react"
// import { useLocation } from "react-router"
// import { Link } from "react-router-dom"
// import { useTranslation } from "react-i18next"
// import {
//   Menu,
//   LinkGroup,
//   LinkItem,
//   OpenToggle,
//   CloseToggle
// } from "./NavigationMenu.style"

// const NavigationMenu = ({ routes }) => {
//   const { t } = useTranslation()
//   const [isOpen, setIsOpen] = useState(false)

//   const handleToggleMenu = useCallback(() => {
//     setIsOpen(open => !open)
//   }, [])

//   const { pathname } = useLocation()
//   const { path: currentLocation } =
//     routes.find(({ path }) => pathname.startsWith(path)) || routes[0]

//   const role = process.env.REACT_APP_ROLE

//   return (
//     <Menu isOpen={isOpen}>
//       {role !== "recipient" && role !== "recipient2" && (
//         <OpenToggle onClick={handleToggleMenu} />
//       )}
//       <LinkGroup>
//         {routes.map(({ path }, index) => (
//           <LinkItem key={path}>
//             <Link onClick={handleToggleMenu} to={isOpen ? path : "#"}>
//               {isOpen
//                 ? t(`navigation.${path}`)
//                 : index === 0
//                 ? t(`navigation.${currentLocation}`)
//                 : t(`navigation.${path}`)}
//             </Link>
//           </LinkItem>
//         ))}
//         <CloseToggle onClick={handleToggleMenu} />
//       </LinkGroup>
//     </Menu>
//   )
// }

// export default NavigationMenu
